import React, { Component, MouseEvent, RefObject } from 'react';
import NextLink from 'next/link';
import { connect } from 'react-redux';
import cx from 'classnames';

import { bindActionCreators, Dispatch } from 'redux';
import { openBusinessOnboardingPopUp } from 'state/actions/applicationUIActions';

import getNextLink from 'utils/getNextLink';

import { BusinessOnboardingPopUpId } from 'constants/Global';

import { Base, AnchorLabel, BuoyChatIcon } from 'styled';
import { Anchor, AnchorInner } from './style';

interface PassedProps {
  ariaLabel: string;
  children?: React.ReactNode;
  className: string;
  containerClassName: string;
  disabled: boolean;
  elemRef?: RefObject<HTMLAnchorElement | NextLink | HTMLButtonElement>;
  variant?:
    | 'primary'
    | 'primary-lg'
    | 'primary-md'
    | 'primary-md-white'
    | 'primary-lg-with-logo'
    | 'tag'
    | 'side-nav-menu'
    | 'symptom-checker-white'
    | 'notification-bar-close'
    | 'underline-white'
    | 'underline-black'
    | 'hover-underline-blue'
    | 'hover-underline-white'
    | 'hover-underline-black'
    | 'hover-underline-gray'
    | 'hero';
  label?: string;
  onClick(e: MouseEvent<HTMLElement>): void;
  onMouseEnter(e: MouseEvent<HTMLElement>): void;
  onMouseLeave(e: MouseEvent<HTMLElement>): void;
  onTouchStart(e: MouseEvent<HTMLElement>): void;
  style: React.CSSProperties;
  to: string;
  wrap?: boolean;
  tabIndex?: number;
  property?: string;
  typeOf?: string;
}

const defaultProps = {
  className: '',
  containerClassName: '',
  disabled: false,
  onClick: () => {},
  onMouseEnter: () => {},
  onMouseLeave: () => {},
  onTouchStart: () => {},
  style: {},
  to: '',
  wrap: false,
};

export type Props = PassedProps & ReturnType<typeof mapDispatchToProps>;

class Link extends Component<Props> {
  static defaultProps = defaultProps;

  handleOnClick = (e: MouseEvent<HTMLElement>) => {
    const { to, onClick, actions } = this.props;

    if (to === BusinessOnboardingPopUpId) {
      actions.openBusinessOnboardingPopUp();
    }

    onClick(e);
  };

  render() {
    const {
      ariaLabel,
      children,
      className,
      containerClassName,
      disabled,
      elemRef,
      variant,
      label,
      onMouseLeave,
      onMouseEnter,
      style,
      to,
      wrap,
      tabIndex,
      property,
      typeOf,
    } = this.props;

    const url = getNextLink(to);
    const variantHasChatIcon =
      variant &&
      ['symptom-checker-white', 'primary-lg-with-logo'].includes(variant);

    const inner = (
      <Anchor
        as="a"
        className={cx('Link__container', containerClassName)}
        variant={variant}
        style={style}
        onClick={this.handleOnClick}
        disabled={disabled}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        aria-label={ariaLabel}
        ref={elemRef as RefObject<HTMLAnchorElement>}
        tabIndex={tabIndex}
        property={property || undefined}
        typeof={typeOf || undefined}
      >
        <AnchorInner
          as="span"
          className={cx('Link', className)}
          wrap={wrap}
          variant={variant}
        >
          {!!children && !label ? (
            children
          ) : (
            <>
              {variantHasChatIcon && (
                <Base
                  as={BuoyChatIcon}
                  primaryColor={
                    variant === 'symptom-checker-white' ? 'blue' : 'white'
                  }
                  secondaryColor={
                    variant === 'symptom-checker-white' ? 'white' : 'blue'
                  }
                  width={['1.25rem', '1.25rem', '1.5rem']}
                  mr={
                    variant === 'primary-lg-with-logo' ? 1.5 : [0.5, 0.5, 0.75]
                  }
                  alignSelf="center"
                />
              )}
              <div>
                <AnchorLabel className="Link__label">{label}</AnchorLabel>
              </div>
            </>
          )}
        </AnchorInner>
      </Anchor>
    );

    if (to === BusinessOnboardingPopUpId) {
      return inner;
    }

    if (typeof url === 'string') {
      return (
        <NextLink href={url} passHref={true} scroll={true}>
          {inner}
        </NextLink>
      );
    }

    return (
      <NextLink href={url.href} as={url.as} passHref={true} scroll={true}>
        {inner}
      </NextLink>
    );
  }
}

const mapDispatchToProps = (dispatch: Dispatch) => ({
  actions: bindActionCreators(
    {
      openBusinessOnboardingPopUp,
    },
    dispatch
  ),
});

export default connect(null, mapDispatchToProps)(Link);
